import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Dialog, Typography } from "@mui/material";
import alertCircle from "@iconify/icons-mdi/alert-circle";
import { InlineIcon } from "@iconify/react";
import { OcTransition } from "oc/components";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyHrTwoFactorWarningDialogProps {
  open: boolean;
  onClose: () => void;
  dateAt: string | number | Date;
}

export const MyHrTwoFactorWarningDialog: React.FC<
  MyHrTwoFactorWarningDialogProps
> = ({ open, onClose, dateAt }) => {
  const isMobile = useOcIsMobile();
  const { t } = useTranslation();

  const date = new Date(dateAt).toLocaleDateString();

  return (
    <>
      <Dialog
        open={open}
        scroll={"body"}
        fullScreen={isMobile}
        TransitionComponent={OcTransition}
        BackdropProps={{
          style: {
            width: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
            backgroundImage: "url(/img/login-background.png)",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundBlendMode: "darken",
          },
        }}
        sx={{ zIndex: 20000 }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          height="inherit"
        >
          <Box width={isMobile ? "auto" : "552px"} padding="36px 24px">
            <Box textAlign="center">
              <InlineIcon icon={alertCircle} width="75px" color="#919699" />
              <Box height="32px" />
              <Typography variant="h5">{t("MY_HR_NOT_SET_UP_2FA")}</Typography>
              <Box height="32px" />
              <Box style={{ textAlign: "left" }}>
                <Typography>{t("MY_HR_2FA_DATE_INFO", { date })}</Typography>
              </Box>
              <Box height="32px" />
              <Button
                id="two-factor-warning-dialog-button"
                variant="contained"
                color="primary"
                disableElevation
                fullWidth={isMobile ? true : false}
                onClick={onClose}
              >
                {t("OC_ALL_RIGHT")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default MyHrTwoFactorWarningDialog;
